import { render, staticRenderFns } from "./MtipocanalcmncFormHeader.vue?vue&type=template&id=38bc1500"
import script from "./MtipocanalcmncFormHeader.vue?vue&type=script&lang=js"
export * from "./MtipocanalcmncFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports